import gsap, { Power2 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';

export class ScrollItem__BlockDefault extends VScroll_Item {
    imgs = [];
    title = [];
    titleBig = [];
    btns = [];
    chars = [];

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.setAnimations();

        this.onShow = () => {
            this.showFunction();
        };
        this.onHide = () => {
            this.hideFunction();
        };
        this.onMove = () => {
            this.moveFunction();
        };
    }

    setAnimations() {
        let img = GetBy.class('__img', this.item);
        if (img.length > 0) {
            this.imgs = img;
            gsap.set(this.imgs, { opacity: 0 });
        }

        let title = GetBy.selector('.__title p', this.item)[0];
        if (!title) title = GetBy.class('__title', this.item)[0];
        if (title) {
            this.title = new SplitText(title, {
                type: 'words',
                wordsClass: 'line-parent',
                charsClass: 'line-child'
            }).words;
            gsap.set(this.title, { opacity: 0 });
        }

        let btns = GetBy.selector('.__btns .button', this.item);
        if (btns.length > 0) {
            this.btns = btns;
            gsap.set(this.btns, { opacity: 0 });
        }

        let titleBig = GetBy.selector('.__title-big p', this.item)[0];
        if (!titleBig) titleBig = GetBy.class('__title-big', this.item)[0];

        if (titleBig) {
            this.titleBig = new SplitText(titleBig, { type: 'words, chars' }).chars;
            gsap.set(this.titleBig, { opacity: 0 });
        }

        let label = GetBy.selector('.__label', this.item)[0];
        if (label) {
            this.chars.push(new SplitText(label, { type: 'chars', tag: 'span', charsClass: 'line-char' }).chars);
            gsap.set(this.chars, { opacity: 0 });
        }

        let list = GetBy.selector('.__chars li', this.item);
        if (list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                const line = list[i];
                this.chars.push(new SplitText(line, { type: 'chars', tag: 'span', charsClass: 'line-char' }).chars);
            }
            gsap.set(this.chars, { opacity: 0 });
        }
    }

    showFunction() {
        let delay = 0;

        for (let i = 0; i < this.chars.length; i++) {
            const line = this.chars[i];
            for (let j = 0; j < line.length; j++) {
                const c = line[j];
                gsap.set(c, {
                    opacity: 1,
                    delay: delay + i * 0.2 + j * 0.01
                });
            }
        }

        for (let i = 0; i < this.title.length; i++) {
            const item = this.title[i];
            gsap.set(item, {
                opacity: 1,
                delay: delay + i * 0.08
            });
        }
        if (this.title.length > 0) delay += .3;

        for (let i = 0; i < this.btns.length; i++) {
            const item = this.btns[i];
            gsap.set(item, { opacity: 1, delay: delay + i * 0.1 });
        }
        if (this.btns.length > 0) delay += .3;

        for (let i = 0; i < this.titleBig.length; i++) {
            const item = this.titleBig[i];
            gsap.set(item, {
                opacity: 1,
                delay: delay + i * 0.02
            });
        }
        if (this.titleBig.length > 0) delay += .3;

        for (let i = 0; i < this.imgs.length; i++) {
            const item = this.imgs[i];
            gsap.to(item, {
                opacity: 1,
                duration: 2,
                delay: delay + i * 0.1 + .1,
                ease: Power2.easeOut
            });
        }
    }

    hideFunction() { }

    moveFunction() { }
}

Scroll._registerClass('BlockDefault', ScrollItem__BlockDefault);
